import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import VueQRCodeComponent from 'vue-qrcode-component'
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            expireDate: null,
            restOfTraining: '',
            role: '',
            useQrCode: false,
            allCustomCategories: [],
            selectedCustomCategories: [],
            languages: [
                {
                    id: 'sr',
                    name: 'Srpski',
                },
                {
                    id: 'en',
                    name: 'English',
                },
            ],
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                username: '',
                role: null
            },
            canExtendPayment: false
        }
    },
    components: {
        VueQRCodeComponent
    },
    methods: {
        load:load,
        update:update,
        deleteAccount: deleteAccount,
        signout: signout,
        editProfile: editProfile,
        resetPassword: resetPassword,
        selectedLanguageClass: selectedLanguageClass,
        selectedLocationClass: selectedLocationClass,
        setLocation: setLocation,
        getIconById: getIconById,
        selectLanguage: selectLanguage,
        extendPayment: extendPayment,
        myPayments: myPayments,
        formatDate:formatDate,
        getStyleLocation: getStyleLocation,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.allCustomCategories = session.getConfig().customCategories.split(";").filter(e => e.length > 0);
        this.selectedCustomCategories = session.getGymLocation() != null && session.getGymLocation().length > 0 ? session.getGymLocation().split(";") : [];
        this.role = session.getRole();
        this.canExtendPayment = session.getConfig().canExtendPayment;
        this.useQrCode = session.getConfig().useQrCode == null ? false : session.getConfig().useQrCode;
        if(CONFIG_COMPANY.LANGUAGES != null){
            this.languages = CONFIG_COMPANY.LANGUAGES;
        }
        this.load()
    }
}

function getIconById(id){
    switch (id) {
        case 'sr': return require('../../../assets/img/language/language_sr.png');
        case 'en': return require('../../../assets/img/language/language_en.png');
        case 'ar': return require('../../../assets/img/language/language_ar.png');
        default: return require('../../../assets/img/language/language_en.png');
    }
}

function load() {
    let _self = this;
    AdminApiService.getProfile()
        .then((response) => {
            _self.model = response.data;
            _self.expireDate = response.data.expireDate;
            if(response.data.restOfTraining > 50 && CONFIG_COMPANY.SHOW_INFINITY_TRAININGS){
                _self.model.restOfTraining = '∞'
            }else {
                _self.model.restOfTraining = '' + response.data.restOfTraining
            }
            // session.setCompanyPayment(response.data.companyPayment)
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function update() {
    let _self = this;
    AdminApiService.updateProfile(_self.model)
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_edit_profile'), 'success')
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    this.$router.push('/reset-password');
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function deleteAccount(){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_delete_account'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        swal(LocService.t('label_success'), LocService.t('label_delete_account_success'), 'success')
        setTimeout(function () {
            _self.$router.push('/login');
            _self.$sessionService.destroyUser();
        }, 800)
    });
}
function extendPayment(){
    let _self = this;
    AdminApiService.extendPayment()
        .then((response) => {
            swal(LocService.t('label_success'), LocService.t('label_success_extend_payment'), 'success')
            _self.load();
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function myPayments(){

    this.$router.push('/payment-user?id=' + this.model.id + '&name=' + this.model.name + ' ' + this.model.surname)
}

function signout(){
    this.$sessionService.destroyUser();
    this.$router.push('/login');
}

function editProfile(){
    this.$router.push('/edit-profile');
}

function selectedLanguageClass(item){
    return session.getLocale() === item ?  'language-item selected' : 'language-item';
}

function selectedLocationClass(item){
    return this.selectedCustomCategories.indexOf(item) !== -1 ?  'language-item selected' : 'language-item';
}

function getStyleLocation(){
    return "width: "+ (100 / this.allCustomCategories.length - 2) +"%;";
}

function setLocation(item){
    if(this.selectedCustomCategories.includes(item)){
        this.selectedCustomCategories = this.selectedCustomCategories.filter(e => e !== item)
    }else{
        this.selectedCustomCategories.push(item)
    }
    var saveLocations = ""
    this.selectedCustomCategories.filter(f => f.length > 0).forEach(e => {
        saveLocations = saveLocations + e +";";
    })
    session.setGymLocation(saveLocations);
}

function selectLanguage(item){
    session.setLocale(item)
    location.reload();
}


// WEBPACK FOOTER //
// ./src/components/Users/Profile/Profile2.js